import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton, SecondaryButton } from "./Buttons.jsx";
import MFASection from "./MFASection.jsx";
import ModalBlank from "./ModalBlank.jsx";
import { FaTriangleExclamation } from "react-icons/fa6";
import { logout } from "../store/app/action.js";

function MFARequiredModal({ isOpen, onClose, onMFAComplete, dismissible = true }) {
  // Import user from Redux to check MFA status
  const { user } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  
  // Check if user has any MFA method set up
  const hasMFA = user?.mfa?.totp_enabled || (user?.mfa?.webauthn_enabled && user?.mfa?.webauthn_credentials?.length > 0);

  return (
    <ModalBlank
      id="mfa-required-modal"
      modalOpen={isOpen}
      setModalOpen={dismissible ? onClose : undefined}
    >
      <div className="p-6">
        <div className="mb-6">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-amber-100 dark:bg-amber-900/50 mx-auto mb-4">
            <FaTriangleExclamation className="w-6 h-6 text-amber-600 dark:text-amber-400" />
          </div>
          <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 text-center mb-2">
            Multi-Factor Authentication Required
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-center">
            Your organization requires multi-factor authentication to be set up before you can access your account. 
            Please set up at least one MFA method below to continue.
          </p>
        </div>

        <div className="mb-6">
          <MFASection showTitle={false} />
        </div>

        <div className="flex justify-between space-x-3">
          <SecondaryButton
            onClick={() => {
              dispatch(logout());
              if (onClose) onClose();
            }}
          >
            Logout
          </SecondaryButton>
          <PrimaryButton
            onClick={() => {
              if (onMFAComplete) {
                onMFAComplete();
              }
            }}
            disabled={!hasMFA}
          >
            Continue
          </PrimaryButton>
        </div>
      </div>
    </ModalBlank>
  );
}

export default MFARequiredModal;
